/* eslint-disable no-unused-vars */

import { CaptionText, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color, lightTheme } from '../../../styles/GlobalStyles';
import { BoxBig, HubImage, Td, Tr } from '../Portfolio.styled';
import moment from 'moment';
import {
  LP,
  formatUSD,
  formatUSDNoDecimals
} from '../../../helpers/helperFunctions';
import { Responsive } from '../../../styles/stylesStyled';
import { useTranslation } from 'react-i18next';
import Spinner from '../../../components/common/Spinner';

import { PortfolioItemDisabled } from '../PortfolioItemDisabled';

export const GardianItem = ({ item }: { item: any }) => {
  const { t } = useTranslation('my_hubs');

  const showConvertedHub = (item: any) => {
    if (item?.dateConverted) {
      return (
        <PortfolioItemDisabled
          title={'You Have Converted this Hub NFT into Loyalty Points'}
          subtitle={
            <>
              Date of conversion:{' '}
              {moment.utc(item?.dateConverted).format('MMM DD, yyyy')} <br />{' '}
              Loyalty Points Received: {formatUSD(item?.loyaltyPoints)} {LP}
            </>
          }
        />
      );
    }
  };

  const returnFractions = (name: string) => {
    switch (name) {
      case 'Starter':
        return 2;
      case 'Basic':
        return 4;
      case 'Builder':
        return 8;
      case 'Pro':
        return 20;

      case 'Promo Starter':
        return 2;

      case 'Promo Basic':
        return 4;
      case 'Promo Builder':
        return 8;
      case 'Promo Pro':
        return 20;

      default:
        break;
    }
  };

  return (
    <>
      <BoxBig relative>
        <HubImage image={item?.imageUrl}>
          {/* <H4 color={color.colors.neutral0}>{item.product?.name}</H4> */}
        </HubImage>
        <div>
          <div
            style={{
              position: 'absolute',
              left: '50%',
              right: '50%',
              transform: 'translate(-50%, -50%)'
            }}>
            <Spinner />
          </div>
          <Tr style={{ cursor: 'pointer' }}>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                ORDER ID
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {item?.id}
              </P1>
            </Td>
            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                PACK PRICE
              </CaptionText>
              <P1 bold flex alignEnd gap='5px'>
                {formatUSDNoDecimals(item.price)} USDT/USDC
              </P1>
            </Td>

            <Td w='20%' wSM='50%'>
              <CaptionText caps bold color={color.colors.neutral500} mb='10'>
                {t('date_of_purchase')}
              </CaptionText>
              <P1 bold>{moment(item?.datePaid).format('DD MMMM YYYY')}</P1>
            </Td>
          </Tr>

          <Flexed column mbSM='20'>
            {item?.name === 'Starter' ? (
              <P2 mb='10' mt='20'></P2>
            ) : (
              <P2 bold color={color.colors.secondary100} mb='10' mt='20'>
                Unica Pay Card Tier: {item?.unicaPay?.name}
              </P2>
            )}

            {item?.minara?.credits && (
              <P2 bold color={color.colors.secondary100} mb='10'>
                Minara Credits: {item?.minara?.credits}
              </P2>
            )}

            <P2 bold color={color.colors.secondary100} mb='10'>
              Academy Access: {item?.u1Academy?.name}
            </P2>
            {item?.name === 'Ultimate' ||
            item?.name === 'Promo Ultimate' ||
            item?.name === 'Elite' ||
            item?.name === 'Promo Elite' ? (
              <P2 bold color={color.colors.secondary100} mb='10'>
                Futura Mining Hardware: UNLIMITED
              </P2>
            ) : (
              <Flexed column>
                <P2 bold color={color.colors.secondary100}>
                  Futura Mining Hardware: Max Fractions -{' '}
                  {returnFractions(item?.name)}
                </P2>
                <P2 bold color={color.colors.secondary100}>
                  (Up To {formatUSDNoDecimals(item?.futuraMining?.limit)}{' '}
                  USDT/USDC)
                </P2>
              </Flexed>
            )}
          </Flexed>
        </div>
        {showConvertedHub(item)}
      </BoxBig>
    </>
  );
};
